jQuery(document).ready(function($){
    $('.owl-home').owlCarousel({
        items: 1,
        loop: true,
        autoplay: true,
        mouseDrag: false,
        touchDrag: false,
        dots: true, 
        nav: false,
        autoplayTimeout: 4000,
        smartSpeed: 4000,
        animateOut: 'fadeOut',
        animateIn: 'fadeIn'
    });
});